<po-page-list p-title="Consulta estoque" [p-filter]="filter">
  <div class="po-m-2">
    <po-input
      classe="po-m-2"
      name="buscaProduto"
      p-label="Buscar produto"
      (p-change-model)="buscaProduto()"
      p-icon="po-icon po-icon-search"
    >
    </po-input>
  </div>
  <po-table
    p-sort="true"
    p-container="light"
    [p-columns]="columns"
    [p-items]="EstoqueList"
    [p-loading]="loading"
    p-container="shadow"
    [p-actions]="actions"
    p-height="300"
    p-striped="true"
  >
  </po-table>
</po-page-list>
